(function() {
'use strict';

const TR = angular.module('TR');
TR.config(['$routeProvider', '$locationProvider', '$httpProvider', '$provide', '$sceDelegateProvider', '$compileProvider', 'popupAuth',
    function($routeProvider, $locationProvider, $httpProvider, $provide, $sceDelegateProvider, $compileProvider, popupAuth) {
    /**
     * this is a horrible hack to make it possible to mandate that a dynamic route param must
     * match a certain regex.
     * Provided modifiers are ! for number, % for guid, and £ for fromUrlV2 route
     * i.e. :tripId% means that we match only if the route param is a guid
     */
    const routeModifiers = {
        '!': '(\\d+)',
        '%': '(.{8}-.{4}-.{4}-.{4}-.{12})',
        '£': '(\\d+-\\d+-\\d+-\\d+)',
        '€': '(\\d+-\\d+(?:-\\d+)?)'
    };
    function pathRegExp(path) {
        const p1 = path.replace(/([().])/g, '\\$1');
        // Add routeModifier to this replace statement
        path = p1.replace(/(\/)?:(\w+)([?*!%£€])?/g, function(_, slash, key, option) {
                const optional = option === '?' ? option : null;
                const star = option === '*' ? option : null;
                const special = routeModifiers[option];
                const keyMatch = (special || (star && '(.+?)' || '([^/]+)'));

                slash = slash || '';
                return `${optional ? '' : slash}(?:${optional ? slash : ''}${keyMatch}${optional || ''})${optional || ''}`;
            })
            .replace(/([/$*])/g, '\\$1');
        return new RegExp(`^${path}/?$`, 'i');
    }

    const $route = $routeProvider.$get[$routeProvider.$get.length - 1]({
        $on() {
            // do nothing
        }
    });
    const when = $routeProvider.when;
    $routeProvider.when = (path, route) => {
        when.apply($routeProvider, [path, route]);
        // Add routeModifier to this list
        if (path && (path.indexOf('!') >= 0 || path.indexOf('%') >= 0 || path.indexOf('£') >= 0 || path.indexOf('€') >= 0)) {
            $route.routes[path].regexp = pathRegExp(path);
        }
    };

    $compileProvider.debugInfoEnabled(TRPCONFIG.DebugInfoEnabled);

    $sceDelegateProvider.resourceUrlWhitelist(['self', `${TRPCONFIG.Domain.CacheDistributionUrl}**`, '/partials/**']);

    const reHasQuery = /^(\w*\/)*\w*\?.*=/;
    const reIsCmsRoute = /^cms\/(component|page)\//;

    $provide.decorator('$sce', ['$delegate', function($delegate) {
        // Adds a version token after every template request
        // in order to better manage the cache
        function addVersion(url) {
            if (
                    url &&
                    url.indexOf('tempver=') === -1 &&
                    url.indexOf('NOVERSION') === -1
                ) {
                const connector = reHasQuery.test(url) ? '&' : '?';
                url += `${connector}cultureCode=${TRPCONFIG.Domain.CultureCode}`;
                url += `&domainId=${TRPCONFIG.Domain.DomainId}`;
                url += `&device=${TRPCONFIG.Domain.DeviceType}`;
                url += `&isAgent=${TRPCONFIG.Domain.isAgentMode}`;
                url += `&udp=${TRPCONFIG.Domain.UserDeviceProfile}`;
                if (!reIsCmsRoute.test(url)) { // No cache busting on CMS routes
                    url += `&tempver=${TRPCONFIG.CurrentVersion}`;
                }
            }

            if (TRPCONFIG.Domain.CloudFrontCachingEnabled && TRPCONFIG.Domain.CloudFrontCachePartials && url != null) {
                url = TRPCONFIG.Domain.CacheDistributionUrl + url;
            }

            return url;
        }

        // ng-include and everything else
        $delegate.getTrusted = (function(original) {
            return function(type, url) {
                return original(type, addVersion(url));
            };
        })($delegate.getTrusted);

        // ng-view and directives
        $delegate.getTrustedResourceUrl = (function(original) {
            return function(url) {
                return original(addVersion(url));
            };
        })($delegate.getTrustedResourceUrl);

        return $delegate;
    }]);

    $locationProvider.hashPrefix('!');

    //this resolver is now only used for the availability path not the landing page path
    const hotelResolver = {
        bookedEstabId: angular.noop,
        hotel: ['hotelResolver', function(hotelResolver) {
            return hotelResolver.resolve(false);
        }]
    };

    const bookingCopyResolver = {
        booking: ['tripService', 'bookingService', '$route', function(tripService, bookingService, $route) {
            return tripService.restoreSearchUnit($route.current.params.tripId).then(function(trip) {
                return bookingService.getBooking(trip.BookingId).then(function(b) {
                    return angular.copy(b);
                });
            });
        }]
    };

    function getCookie(key) {
        // this logic has been duplicated from CookieService which we can't access here
        if (!key) { return null; }
        return decodeURIComponent(document.cookie.replace(new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1')) || null;
    }

    function getDestination() {
        const json = $('body').attr('destination');
        return json == null ? null : JSON.parse(json);
    }

    $routeProvider.when('/impersonate_customer/:tenantId/:customerId:params?', {
        template: '<div></div>',
        controller: ($location, $routeParams, authService, bookingService, loggingService) => {
            const { tenantId, customerId, trackingTag } = $routeParams;
            const domainTenantId = parseInt(TRPCONFIG.Domain.TenantId);

            //double check that the tenant supplied is the tenant that we are actually on
            if (domainTenantId === parseInt(tenantId)) {
                //note that this will fail if the user is not signed in as an agent - we are not handling that possibility
                authService.impersonatedSignIn(customerId.toUpperCase())
                    .then(() => bookingService.setTrackingTag(trackingTag))
                    //impersonation is complete - redirect to the homepage
                    .then(() => $location.url('/'))
                    .catch(err => {
                        $location.url('/error');
                        loggingService.logWarn(
                            'Impersonation has failed. Please check your permissions, tenant id and customer id. Error: ', JSON.stringify(err)
                        );
                    });
            } else {
                $location.url('/');
            }
        }
    });

    function forwardToManageYourBooking(operation) {
        return [
            '$location',
            '$http',
            '$routeParams',
            'authService',
            'currentUser',
            'v1Redirection',
            'loggingService',
            function(
                $location,
                $http,
                $routeParams,
                authService,
                currentUser,
                v1Redirection,
                loggingService
            ) {
                const { tenantId, bookingId, trackingTag, categoryId } = $routeParams;
                const domainTenantId = parseInt(TRPCONFIG.Domain.TenantId);
                const user = currentUser.get();

                const authenticateBookingCallback = () => {
                    if (domainTenantId === parseInt(tenantId)) {
                        authService.bookingSignInByAgent(bookingId)
                            .then(anonSignedIn => {
                                if (!anonSignedIn) {
                                    $location.url('/');
                                    return;
                                }
                                const { Contact, BookingSummary } = currentUser.get();
                                v1Redirection.v1Redirect({
                                    SID: BookingSummary.SiteId,
                                    BID: BookingSummary.BookingId,
                                    SN: Contact.LastName,
                                    NAV: operation,
                                    trackingTag,
                                    categoryId
                                });
                            })
                            .catch(err => {
                                loggingService.logWarn(
                                    `Error signing in booking. Please check permissions, tenant id and booking id. Error: ${JSON.stringify(err)}`
                                );
                            });
                    } else {
                        $location.url('/');
                    }
                };
                if (user.AnonSignedIn || user.SignedIn) {
                    return $http.post('/api2/managebooking/signout').then(authenticateBookingCallback);
                }
                // Attempt to logout user if it's logged in, but continue execution if it's not logged in
                authenticateBookingCallback();
            }];
    }

    $routeProvider.when('/update_booking/:tenantId/:bookingId', {
        template: '<div></div>',
        controller: forwardToManageYourBooking('options')
    });

    $routeProvider.when('/raise_csr/:tenantId/:bookingId:params?', {
        template: '<div></div>',
        controller: forwardToManageYourBooking('amend')
    });



    // duplicates impersonate customer for now
    $routeProvider.when('/new_quote/:tenantId/:customerId:params?', {
        template: '<div></div>',
        controller: ($location, $routeParams, authService, quoteService) => {
            const { tenantId, customerId, trackingTag } = $routeParams;
            //double check that the tenant supplied is the tenant that we are actually on
            if (TRPCONFIG.Domain.TenantId === parseInt(tenantId)) {
                //note that this will fail if the user is not signed in as an agent - we are not handling that possibility
                authService.impersonatedSignIn(customerId.toUpperCase())
                    .then(() => quoteService.setTrackingTag(trackingTag))
                    //impersonation is complete - redirect to the homepage
                    .then(() => $location.url('/'));
            }
        }
    });

    $routeProvider.when('/update_quote/:tenantId/:quoteReference', {
        template: '<div></div>',
        controller: ($location, $routeParams, quoteService, loggingService) => {
            const { tenantId, quoteReference } = $routeParams;
            const domainTenantId = parseInt(TRPCONFIG.Domain.TenantId);

            if (domainTenantId !== parseInt(tenantId) && quoteReference.length < 1) {
                return $location.url('/');
            }

            quoteService.getQuoteByReference(`QUO/${quoteReference}`)
                .then(quote => {
                    if (quote && !quote.Error) {
                        $location.url(`/quote/manage/QUO/${quoteReference}`);
                        return;
                    }
                    loggingService.logWarn('Quote was not impersonated without error');
                    $location.url('/');
                })
                .catch(err => {
                    loggingService.logWarn(
                        'Error while signing a quote. Please check the permissions, tenant id and quoute id', JSON.stringify(err)
                    );
                });
        }
    });


    $routeProvider.when('/agents/signin', {
        templateUrl: 'partials/agents/signin',
        controllerAs: 'cm',
        controller: 'Agent'
    });

    $routeProvider.when('/agents/settings', {
        templateUrl: 'partials/agents/settings',
        controllerAs: 'cm',
        controller: 'Debug'
    });

    $routeProvider.when('/agents/initiateresetpassword', {         //route to initiate reset password
        templateUrl: 'livepartials/agents/initiateresetpassword',
        controllerAs: 'cm',
        controller: 'Agent'
    });

    $routeProvider.when('/admin/resetpassword', {         //route to reset password
        templateUrl: 'livepartials/agents/resetpassword',
        controllerAs: 'cm',
        controller: 'Agent'
    });

    $routeProvider.when('/agents/resetsuccessful', {
        templateUrl: 'livepartials/agents/resetsuccessful',
        controllerAs: 'cm',
        controller: 'Agent'
    });

    function configAuthRoutesMyb() {
        const path = 'bookingsignin';
        $routeProvider.when(`/${path}`, popupAuth ? {
            resolve: {
                redirect: ['authRedirection', authRedirection => authRedirection.authRedirect(path)]
            }
        } : {
            templateUrl: `partials/auth/${path}`,
            controllerAs: 'cm',
            controller: 'Auth'
        });
    }

    function configureAuthRoutes() {
        ['signin', 'signup', 'bookingsignin', 'forgot'].forEach(path => {
            $routeProvider.when(`/${path}`, popupAuth ? {
                resolve: {
                    redirect: ['authRedirection', authRedirection => authRedirection.authRedirect(path)]
                }
            } : {
                templateUrl: `partials/auth/${path}`,
                controllerAs: 'cm',
                controller: 'Auth'
            });
        });

        $routeProvider.when('/customer/changepassword', {     //route to actually perform the reset
            templateUrl: 'partials/auth/reset',
            controllerAs: 'cm',
            controller: 'Auth'
        });

        $routeProvider.when('/customer/verify', {
            templateUrl: 'partials/auth/verify',
            controllerAs: 'cm',
            controller: 'Auth'
        });

        $routeProvider.when('/customer/verifyandchoosepassword', {
            templateUrl: 'partials/auth/activate',
            controllerAs: 'cm',
            controller: 'Auth'
        });

        $routeProvider.when('/resetsuccessful', {         //route to confirm the password has *been* changed
            templateUrl: 'partials/auth/resetsuccessful',
            controllerAs: 'cm',
            controller: 'Auth'
        });

        $routeProvider.when('/verified', {
            templateUrl: 'partials/auth/verified',
            controllerAs: 'cm',
            controller: 'Auth'
        });

        if (!popupAuth) {
            $routeProvider.when('/changeemailsent', {
                templateUrl: 'partials/auth/changeemailsent',
                controllerAs: 'cm',
                controller: 'Auth'
            });
            $routeProvider.when('/verificationsent', {
                templateUrl: 'partials/auth/verificationsent',
                controllerAs: 'cm',
                controller: 'Auth'
            });

            $routeProvider.when('/resetsent', {     //route to confirm reset instructions sent
                templateUrl: 'partials/auth/resetsent',
                controllerAs: 'cm',
                controller: 'Auth'
            });
        }
    }

    function getBookingFormTemplate(area) {
        if ((!TRPCONFIG.Domain.isAgentMode || TRPCONFIG.Domain.BookingFormV2OnAgentEnabled) && !isMobileSite()) {
            const version = parseFloat(TRPCONFIG.Domain.BookingFormVersion);
            if (version > 2) {
                if (TRPCONFIG.Domain.BookingFormABTest) {
                    const cookieVersion = getCookie('BookingFormVersion');
                    if (parseFloat(cookieVersion) > 2) {
                        return `partials/booking/template?name=Book&version=${cookieVersion}`;
                    }
                } else {
                    return `partials/booking/template?name=Book&version=${version}`;
                }
            }
        }
        return `partials/${area}/book`;
    }

    function configureCommonRoutes(areas) {
        angular.forEach(areas, function(area) {
            $routeProvider.when(`/${area}/search-${area}.aspx`, {
                redirectTo: area
            });

            $routeProvider.when(`/${area}`, {
                templateUrl: `partials/${area}/index`,
                controller: 'Home',
                controllerAs: 'cm',
                area
            });
            $routeProvider.when(`/${area}/notfound`, {
                templateUrl: 'partials/home/searchnotfound',
                controllerAs: 'cm',
                controller: 'NotFound',
                area
            });


            $routeProvider.when(`/${area}/destination`, {
                templateUrl: 'partials/home/destination',
                controller: 'SearchUnit',
                controllerAs: 'cm',
                area
            });

            $routeProvider.when(`/${area}/occupancy`, {
                templateUrl: `partials/${area}/occupancy`,
                controller: 'Occupancy',
                controllerAs: 'cm',
                area
            });

            $routeProvider.when(`/${area}/book/:tripId%`, {
                templateUrl: getBookingFormTemplate(area),
                controllerAs: 'cm',
                controller: 'Booking',
                area,
                analyticsTag: 'Complete your Booking',
                pixelTrackingPageName: `${area}BookingForm`,
                noGroup: true,
                hideDistractionLinks: true,
                hideTravelAgentLinks: true,
                breadcrumb: {
                    crumb: 50
                }
            });

            $routeProvider.when(`/${area}/book/:tripId%/:direction/departuredate`, {
                templateUrl: `partials/${area}/departuredate`,
                controllerAs: 'cm',
                controller: 'FlightCapture',
                resolve: bookingCopyResolver,
                hideDistractionLinks: true,
                hideTravelAgentLinks: true
            });

            $routeProvider.when(`/${area}/book/:tripId%/:direction/departureairport`, {
                templateUrl: `partials/${area}/departureairports`,
                controllerAs: 'cm',
                controller: 'FlightCapture',
                area: 'flights',
                noGroup: true,
                resolve: bookingCopyResolver,
                hideDistractionLinks: true,
                hideTravelAgentLinks: true
            });

            $routeProvider.when(`/${area}/book/:tripId%/:direction/destinationairport`, {
                templateUrl: `partials/${area}/destinationairports`,
                controllerAs: 'cm',
                controller: 'FlightCapture',
                area: 'flights',
                resolve: bookingCopyResolver,
                hideDistractionLinks: true,
                hideTravelAgentLinks: true
            });

            $routeProvider.when(`/${area}/departureairport`, {
                templateUrl: `partials/${area}/searchunitdepartureairports`,
                controller: [
                    '$window', 'searchUnitService', function($window, searchUnitService) {
                        const cm = this;
                        cm.setDepartureAirport = function(item) {
                            searchUnitService.setDepartureAirports(item);
                            setTimeout(function() {
                                $window.history.back();
                            }, 0);
                        };
                    }
                ],
                controllerAs: 'cm',
                area: 'flights'
            });
        });
    }

    function configureHotelRoutes() {
        //make sure that this doesn't get incorrectly interpreted as availability results
        $routeProvider.when('/hotels/hotel-listings.aspx', {
            redirectTo: '/hotels'
        });

        $routeProvider.when('/hotels/:tripId%', {
            templateUrl: 'partials/hotels/hotelsearch',
            area: 'hotels',
            analyticsTag: 'Hotel Selection',
            pixelTrackingPageName: 'hotelsSearchResults',
            reloadOnSearch: false,
            breadcrumb: {
                crumb: 20
            }
        });
        $routeProvider.when('/hotels/:tripId%/:estabId', {
            templateUrl: 'partials/hotels/availability',
            controller: 'HotelAvailability',
            controllerAs: 'cm',
            area: 'hotels',
            analyticsTag: 'Room Selection',
            pixelTrackingPageName: 'hotelsRoomSelection',
            resolve: hotelResolver,
            breadcrumb: {
                crumb: 21,
                squash: true
            }
        });
    }

    $routeProvider.when('/sitemap/:landingPageV3£/:urlText*', {
        templateUrl: 'partials/hotels/hotelssitemap',
        controller: 'HotelsSitemap',
        controllerAs: 'cm',
        area: 'hotels'
    });

    $routeProvider.when('/sitemap/:landingPageV2€/:urlText*', {
        templateUrl: 'partials/hotels/hotelssitemap',
        controller: 'HotelsSitemap',
        controllerAs: 'cm',
        area: 'hotels'
    });

    function configureHolidayRoutes() {
        $routeProvider.when('/holidays/departure', {
            templateUrl: 'partials/holidays/departure',
            controller: 'Departure',
            controllerAs: 'cm'
        });
        $routeProvider.when('/holidays/flights/search', {
            templateUrl: 'partials/holidays/flightsearch',
            controller: ['flightSearch', '$location', 'hotelSearch', function(flightSearch, $location, hotelSearch) {
                flightSearch.search().then(function(data) {
                    hotelSearch.search(data.AvailabilitySearchId);
                    $location.path(`/holidays/flights/${data.AvailabilitySearchId}`);
                });
            }]
        });

        $routeProvider.when('/holidays/flights/:tripId%', {
            templateUrl: 'partials/holidays/flightresults',
            controller: 'HolidaySearch',
            controllerAs: 'cm',
            area: 'holidays',
            analyticsTag: 'Choose your Flight',
            pixelTrackingPageName: 'holidaysFlightSearch',
            breadcrumb: {
                crumb: 10
            }
        });

        $routeProvider.when('/holidays/hotels/:tripId%', {
            templateUrl: 'partials/holidays/hotelsearch',
            reloadOnSearch: false,
            area: 'holidays',
            analyticsTag: 'Choose your Hotel',
            pixelTrackingPageName: 'holidaysHotelsSearchResults',
            breadcrumb: {
                crumb: 20
            }
        });

        $routeProvider.when('/holidays/january-sale', {
            template: '<div></div>',
            controller: ['$scope', 'resourceService', 'basketService', ($scope, resourceService, basketService) => {
                $scope.$emit('block', {
                    title: resourceService.get('SEARCHINGHOTELS'),
                    subtitle: resourceService.get('THISMAYTAKE'),
                    loadingScreenStyle: 'default-searchUnitCtrl'
                });
                basketService.startMultiDestHolidayWorkflow();
            }]
        });

        $routeProvider.when('/holidays/january-sale/:tripId%', {
            templateUrl: 'partials/holidays/hotelsearch?multiDestination=true',
            // HTML has `ng-controller="HotelSearch as cm"`
            reloadOnSearch: false,
            area: 'holidays',
            analyticsTag: 'Hotel Selection',
            pixelTrackingPageName: 'holidaysJanuarySale'
        });

        $routeProvider.when('/holidays/options/:tripId%/:productId?', {
            templateUrl: 'partials/holidays/options',
            controllerAs: 'cm',
            controller: 'Options',
            area: 'holidays',
            analyticsTag: 'Customize your Holiday',
            pixelTrackingPageName: 'holidaysOptions',
            hideDistractionLinks: true,
            breadcrumb: {
                crumb: 40
            }
        });

        $routeProvider.when('/hotels/options/:tripId%', {
            templateUrl: 'partials/hotels/hoteloptions',
            controllerAs: 'cm',
            controller: 'HotelOptions',
            area: 'hotels',
            analyticsTag: 'HotelOptions',
            pixelTrackingPageName: 'hotelsOptions',
            hideDistractionLinks: true,
            breadcrumb: {
                crumb: 40
            }
        });

        $routeProvider.when('/holidays/:tripId%/:estabId', {
            templateUrl: 'partials/holidays/availability',
            controller: 'HotelAvailability',
            controllerAs: 'cm',
            area: 'holidays',
            analyticsTag: 'Choose your Room',
            pixelTrackingPageName: 'holidaysRoomSelection',
            reloadOnSearch: false,
            resolve: hotelResolver,
            breadcrumb: {
                crumb: 21,
                squash: true
            }
        });

        if (TRPCONFIG.Domain.AprilCampaignRoutes) {
            TRPCONFIG.Domain.AprilCampaignRoutes.forEach(url => {
                $routeProvider.when(`/${url}`, {
                    templateUrl: 'partials/holidaydeals/aprilcampaign',
                    controller: 'seasonalDeals',
                    controllerAs: 'sd',
                    area: 'holidays',
                    reloadOnSearch: false
                });
            });
        }

        if (TRPCONFIG.Domain.ActiveSeasonalDeals) {
            TRPCONFIG.Domain.ActiveSeasonalDeals.forEach(deal => {
                $routeProvider.when(deal.Url, {
                    templateUrl: `partials/holidaydeals/seasonaldeals?seasonCode=${deal.SeasonCode}`,
                    controller: 'seasonalDeals',
                    controllerAs: 'sd',
                    area: 'holidays',
                    reloadOnSearch: false
                });
            });
        }

        if (TRPCONFIG.Domain.LastMinuteDealsPageEnabled) {
            $routeProvider.when('/holidaydeals:params?', {
                templateUrl: 'partials/holidaydeals/lastminutedealspromo',
                controller: 'lastMinuteDeals',
                controllerAs: 'ldp',
                area: 'holidays',
                reloadOnSearch: false
            });
            $routeProvider.when('/holidaydealspromo/:params?', {
                redirectTo: '/holidaydeals'
            });
            $routeProvider.when('/holidaydeals/occupancy', {
                templateUrl: 'partials/holidaydeals/occupancy',
                controller: 'Occupancy',
                controllerAs: 'cm',
                area: 'holidays'
            });
        } else {
            $routeProvider.when('/holidaydeals/:params?', {
                templateUrl: 'partials/holidaydeals/holidaydealsresults',
                controller: 'HolidayDealsResults',
                controllerAs: 'hd',
                area: 'holidays',
                reloadOnSearch: false
            });
            $routeProvider.when('/holidaydealspromo/:params?', {
                templateUrl: 'partials/holidaydeals/holidaydealspromo',
                controller: 'HolidayDealsPromo',
                controllerAs: 'hdp',
                area: 'holidays',
                reloadOnSearch: false
            });
        }

        $routeProvider.when('/offers/early-summer-2019-holidays', {
            redirectTo: '/offers/early-summer-holidays'
        });

        $routeProvider.when('/recommendations/loading', {
            templateUrl: 'partials/recommendations/loading',
            controller: 'Loading',
            controllerAs: 'ld'
        });
    }

    function configureTransferRoutes() {
        $routeProvider.when('/transfers/destinationairports', {
            templateUrl: 'partials/home/destinationairports',
            controller: 'TransferAirports',
            controllerAs: 'cm',
            area: 'transfers'
        });
        $routeProvider.when('/transfers/resorts', {
            templateUrl: 'partials/home/resorts',
            controller: 'Resorts',
            controllerAs: 'cm'
        });
        $routeProvider.when('/transfers/direction', {
            templateUrl: 'partials/home/direction',
            controller: 'TransferDirection',
            controllerAs: 'cm',
            area: 'transfers'
        });
        $routeProvider.when('/transfers/departuredate', {
            templateUrl: 'partials/transfers/arrivaldate',
            controller: 'SearchUnit',
            controllerAs: 'cm',
            area: 'transfers'
        });
        $routeProvider.when('/transfers/returndate', {
            templateUrl: 'partials/transfers/returndate',
            controller: 'SearchUnit',
            controllerAs: 'cm',
            area: 'transfers'
        });
        $routeProvider.when('/transfers/:tripId%', {
            templateUrl: 'partials/transfers/search',
            controller: 'TransferSearch',
            controllerAs: 'cm',
            area: 'transfers',
            analyticsTag: 'Transfer Selection',
            pixelTrackingPageName: 'transfersSearchResults',
            breadcrumb: {
                crumb: 30
            }
        });
    }

    function isMobileSite() {
        return TRPCONFIG.IsMobileView;
    }

    function configureMarhabaRoutes() {
        $routeProvider.when('/marhaba', {
            templateUrl: 'partials/marhaba/index',
            controller: 'Home',
            area: 'marhaba'
        });

        $routeProvider.when('/marhaba/occupancy', {
            templateUrl: 'partials/marhaba/occupancy',
            controller: 'Occupancy',
            controllerAs: 'cm',
            area: 'marhaba'
        });
        $routeProvider.when('/marhaba/book/:tripId%/:productId', {
            templateUrl: () => getBookingFormTemplate('marhaba'),
            controllerAs: 'cm',
            controller: 'Booking',
            area: 'marhaba',
            noGroup: true,
            pixelTrackingPageName: 'marhabaBookingForm',
            hideDistractionLinks: true,
            hideTravelAgentLinks: true
        });

        $routeProvider.when('/marhaba/departuredate', {
            templateUrl: 'partials/transfers/arrivaldate',
            controller: 'SearchUnit',
            controllerAs: 'cm',
            area: 'marhaba'
        });
        $routeProvider.when('/marhaba/destinationairports', {
            templateUrl: 'partials/marhaba/marhabaairports',
            controller: 'MarhabaAirports',
            controllerAs: 'cm',
            area: 'marhaba'
        });
        $routeProvider.when('/marhaba/terminal', {
            templateUrl: 'partials/marhaba/terminal',
            controller: 'Terminal',
            controllerAs: 'cm',
            area: 'marhaba'
        });
        $routeProvider.when('/marhaba/flighttype', {
            templateUrl: 'partials/marhaba/flighttype',
            controller: 'FlightType',
            controllerAs: 'cm',
            area: 'marhaba'
        });
        $routeProvider.when('/marhaba/notfound', {
            templateUrl: 'partials/marhaba/searchnotfound'
        });
        $routeProvider.when('/marhaba/connectingairport/:tripId%/:productId?', {
            templateUrl: 'partials/marhaba/destinationairports',
            controller: 'ConnectingAirport',
            controllerAs: 'cm',
            area: 'marhaba'
        });
        $routeProvider.when('/marhaba/:tripId%/:productId', {
            templateUrl: 'partials/marhaba/options',
            controller: 'MarhabaOptions',
            pixelTrackingPageName: 'marhabaOptions',
            controllerAs: 'cm',
            area: 'marhaba'
        });
        $routeProvider.when('/marhaba/book/:tripId%/passenger/:room/:index/:productId', {
            templateUrl: 'partials/holidays/passenger',
            controller: 'Passenger',
            controllerAs: 'cm',
            hideDistractionLinks: true,
            hideTravelAgentLinks: true
        });
        $routeProvider.when('/marhaba/:tripId%', {
            templateUrl: 'partials/marhaba/availability',
            controller: 'MarhabaAvailability',
            pixelTrackingPageName: 'marhabaSearchResults',
            controllerAs: 'cm',
            area: 'marhaba'
        });
    }

    function configureParkingRoutes() {
        const area = 'parking';

        $routeProvider.when('/parking', {
            templateUrl: 'partials/parking/index',
            controllerAs: 'cm',
            controller: 'ParkingSearchUnit',
            area
        });

        $routeProvider.when(`/${area}/dropoffdate`, {
            templateUrl: `partials/${area}/dropoffdate`,
            controller: 'ParkingSearchUnit',
            controllerAs: 'cm',
            area
        });

        $routeProvider.when(`/${area}/pickupdate`, {
            templateUrl: `partials/${area}/pickupdate`,
            controller: 'ParkingSearchUnit',
            controllerAs: 'cm',
            area
        });

        $routeProvider.when(`/${area}/occupancy`, {
            templateUrl: `partials/${area}/occupancy`,
            controller: 'Occupancy',
            controllerAs: 'cm',
            area
        });

        $routeProvider.when(`/${area}/departureairport`, {
            templateUrl: `partials/${area}/searchunitdepartureairports`,
            controller: [
                '$window', 'searchUnitService', function($window, searchUnitService) {
                    const cm = this;
                    cm.setDepartureAirport = function(item) {
                        searchUnitService.setDepartureAirports(item);
                        setTimeout(function() {
                            $window.history.back();
                        }, 0);
                    };
                }
            ],
            controllerAs: 'cm',
            area
        });

        $routeProvider.when(`/${area}/:tripId%`, {
            templateUrl: 'partials/parking/parkingresults',
            controllerAs: 'cm',
            controller: 'ParkingResults',
            area,
            analyticsTag: 'Parking Selection',
            breadcrumb: {
                crumb: 35
            }
        });
    }

    function configureInsuranceRoutes() {
        $routeProvider.when('/insurance', {
            templateUrl: 'partials/insurance/index',
            controller: 'Home',
            area: 'insurance'
        });
        $routeProvider.when('/insurance/book/:tripId%', {
            templateUrl: getBookingFormTemplate('insurance'),
            controllerAs: 'cm',
            controller: 'Booking',
            area: 'insurance',
            noGroup: true,
            hideDistractionLinks: true,
            hideTravelAgentLinks: true
        });
        $routeProvider.when('/insurance/notfound', {
            templateUrl: 'partials/insurance/searchnotfound',
            controller: 'NotFound',
            controllerAs: 'cm'
        });
        $routeProvider.when('/insurance/results/:tripId%', {
            templateUrl: 'partials/insurance/insuranceresults',
            controller: 'InsuranceResults',
            pixelTrackingPageName: 'insuranceSearchResults',
            controllerAs: 'cm',
            area: 'insurance'
        });
    }

    function termsProviderTemplate(params) {
        let sup = '';
        angular.forEach(params.suppliers.split('|'), function(s) {
            sup += `&suppliers=${s}`;
        });
        return String.format('partials/terms/provider?cultureCode={0}&bookingProcessId={1}{2}&transferRateId={3}',
            params.culture,
            params.bookingId,
            sup,
            params.transferRate);
    }

    function configureHelpRoutes() {
        $routeProvider.when('/help', {
            templateUrl: 'partials/help/index',
            analyticsTag: ' Help'
        });
        angular.forEach(TRPCONFIG.Domain.HelpRoutes || [], function(path) {
            $routeProvider.when(`/help/${path}`, {
                templateUrl: `partials/help/${path}`,
                analyticsTag: 'Help'
            });
        });

        $routeProvider.when('/terms/agency', {
            templateUrl: 'partials/terms/agency',
            analyticsTag: 'Terms',
            pixelTrackingPageName: 'termsAgency'
        });

        //we need to have a special hard-coded italian route here temporarily due to an error
        //in the ios app
        $routeProvider.when('/termini/fornitore/:culture/:bookingId/:suppliers/:transferRate?', {
            templateUrl: termsProviderTemplate
        });

        $routeProvider.when('/terms/provider/:culture/:bookingId/:suppliers/:transferRate?', {
            templateUrl: termsProviderTemplate
        });
    }

    function configureFlightsRoutes() {
        $routeProvider.when('/flights/destinationairports', {
            templateUrl: 'partials/home/destinationairports',
            controller: 'TransferAirports',
            controllerAs: 'cm',
            area: 'flights'
        });

        $routeProvider.when('/flights/:tripId%', {
            templateUrl: 'partials/flights/flightresults',
            controller: 'HolidaySearch',
            controllerAs: 'cm',
            pixelTrackingPageName: 'flightsSearchResults',
            area: 'flights',
            breadcrumb: {
                crumb: 10
            }
        });

        $routeProvider.when('/multiflights/:tripId%', {
            templateUrl: 'partials/flights/multiflightresults',
            controller: 'MultiFlightsSearch',
            controllerAs: 'mfs',
            area: 'multisector'
        });
    }

    if (TRPCONFIG.Domain.UseIdBasedHotelUrls) {
        $routeProvider.when('/:landingPageV2€/:urlText*', {
            templateUrl: 'partials/landingpage/landingcontainer?landing=true',
            area: 'hotels',
            analyticsTag: 'Landing Page',
            pixelTrackingPageName: 'landingPage',
            controller: 'LandingPage',
            controllerAs: 'lp',
            reloadOnSearch: false,
            landing: true
        });
    }
    if (TRPCONFIG.Domain.UrlRouteTesting || TRPCONFIG.Domain.UseIdBasedUrls) {
        $routeProvider.when('/:landingPageV3£/:urlText*', {
            templateUrl: 'partials/landingpage/landingcontainer?landing=true',
            controller: 'LandingPage',
            analyticsTag: 'Landing Page',
            pixelTrackingPageName: 'landingPage',
            controllerAs: 'lp',
            reloadOnSearch: false,
            landing: true
        });
        $routeProvider.when('/:urlText*/:landingPageV4£', {
            templateUrl: 'partials/landingpage/landingcontainer?landing=true',
            controller: 'LandingPage',
            controllerAs: 'lp',
            analyticsTag: 'Landing Page',
            pixelTrackingPageName: 'landingPage',
            reloadOnSearch: false,
            landing: true
        });
    }

    $routeProvider.when('/:landingPage*.html', {
        templateUrl: 'partials/landingpage/landingcontainer?landing=true',
        controller: 'LandingPage',
        analyticsTag: 'Landing Page',
        pixelTrackingPageName: 'landingPage',
        controllerAs: 'lp',
        reloadOnSearch: false,
        landing: true
    });

    function configureProductRoutes(product) {
        switch (product) {
            case 'hotels':
                configureHotelRoutes();
                break;
            case 'flights':
                configureFlightsRoutes();
                break;
            case 'holidays':
                configureHolidayRoutes();
                break;
            case 'transfers':
                configureTransferRoutes();
                break;
            case 'marhaba':
                configureMarhabaRoutes();
                break;
            case 'parking':
                configureParkingRoutes();
                break;
            case 'insurance':
                configureInsuranceRoutes();
                break;
        }
    }

    //we still need to handle the old landing page routes for the time being
    function rerouteOldLandingPage(args, $route, destinationService, $location, urlUtils) {
        $route.current.$$route.area = args.area;
        destinationService.getDetails({
            CountryId: args.countryId,
            ProvinceId: args.provinceId,
            LocationId: args.locationId,
            PlaceId: args.placeId,
            PolygonId: args.polygonId,
            EstablishmentId: 0
        }, { fields: 'PagePath' }).then(function(dest) {
            $location.path(urlUtils.stripLeadingSlash(dest.PagePath));
        });
    }

    $routeProvider.when('/:area/hotel/:estabId', {
        template: '<div></div>',
        controller($route, $routeParams, $location, hotelRehydrator, urlUtils, pageStrand) {
            $route.current.$$route.area = $routeParams.area;
            const strand = pageStrand.fromRoute();
            hotelRehydrator.hotels([$routeParams.estabId], { fields: ['Id', 'Url'] }).then(function(hotels) {
                $location.url(pageStrand.adjustUrl(urlUtils.stripLeadingSlash(hotels[0].Url), strand));
            });
        }
    });

    $routeProvider.when('/:area/destination/:countryId/:provinceId/:locationId/:placeId/:polygonId', {
        template: '<div></div>',
        controller($route, $routeParams, $location, destinationService, urlUtils) {
            rerouteOldLandingPage($routeParams, $route, destinationService, $location, urlUtils);
        }
    });

    $routeProvider.when('/:area/destination/:countryId', {
        template: '<div></div>',
        controller($route, $routeParams, $location, destinationService, urlUtils) {
            rerouteOldLandingPage({
                area: $routeParams.area,
                countryId: $routeParams.countryId,
                provinceId: 0,
                locationId: 0,
                placeId: 0,
                polygonId: 0
            }, $route, destinationService, $location, urlUtils);
        }
    });

    const commonRoutes = [];

    const supportedProducts = TRPCONFIG.Domain.SupportedProducts;
    const products = {
        none: 0,
        hotels: 1,
        flights: 2,
        holidays: 4,
        transfers: 8,
        carhire: 16,
        marhaba: 32,
        // attractions: 64,
        parking: 128,
        insurance: 256
    };

    function isSupported(product) {
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators#Flags_and_bitmasks
        // eslint-disable-next-line no-bitwise
        return (products[product] | supportedProducts) === supportedProducts;
    }

    ['flights', 'holidays', 'transfers', 'hotels', 'parking'].forEach(product => {
        if (isSupported(product)) {
            commonRoutes.push(product);
        }
    });

    configureCommonRoutes(commonRoutes);

    ['hotels', 'flights', 'holidays', 'transfers', 'marhaba', 'parking', 'insurance'].forEach(product => {
    // NOTE: attractions routes defined in attractions.config.ts
        if (isSupported(product)) {
            configureProductRoutes(product);
        }
    });

    configureAuthRoutes();

    // New config function For EKH MYB, only the dashboard sign in is available
    if (TRPCONFIG.Domain.DashboardBookingEnabled) {
        configAuthRoutesMyb();
    }

    configureHelpRoutes();

    $routeProvider.when('/booking/complete/paypal/:tripId%/:ref*', {
        controller: 'BookingComplete',
        controllerAs: 'cm',
        analyticsTag: 'Booking Complete',
        inTransactionalFlow: true,
        hideFooterToolbar: true,
        templateUrl(params) {
            const qs = `?bookingRef=${params.ref.split('|').join('&bookingRef=')}`;
            return `partials/home/bookingcomplete${qs}`;
        }
    });

    $routeProvider.when('/booking/complete/:ref*', {
        controller: 'BookingComplete',
        controllerAs: 'cm',
        analyticsTag: 'Booking Complete',
        pixelTrackingPageName: 'bookingComplete',
        inTransactionalFlow: true,
        hideFooterToolbar: true,
        templateUrl(params) {
            const qs = `?bookingRef=${params.ref.split('|').join('&bookingRef=')}`;
            return `partials/home/bookingcomplete${qs}`;
        }
    });

    $routeProvider.when('/booking/complete', {
        templateUrl: 'partials/home/bookingcomplete',
        analyticsTag: 'Booking Complete',
        inTransactionalFlow: true,
        hideFooterToolbar: true,
        controller($scope, broker) {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
    });

    function createDesktopCookie(domain) {
        const name = 'trpDesktop';
        const date = new Date();
        date.setTime(date.getTime() + (2 * 60 * 60 * 1000));
        document.cookie = String.format(`{0}={0}; expires={1}; path=/; domain=${domain}`, name, date.toGMTString());
    }

    $routeProvider.when('/desktop-myb/:SID/:BID/:SN/:NAV', {
        template: '<div></div>',
        controller: ['$routeParams', function($p) {
            const domain = TRPCONFIG.Domain.HostName;
            let desktopUrl = `https://www.${domain}`;
            desktopUrl += '/manage-your-booking/login.aspx';
            desktopUrl += `?SID=${$p.SID}&BID=${$p.BID}&SN=${$p.SN}`;
            desktopUrl += `&navpage=${$p.NAV}`;

            createDesktopCookie(domain);
            location.replace(desktopUrl);
        }]
    });

    $routeProvider.when('/desktop-site', {
        template: '<div></div>',
        controller: [function() {
            const domain = TRPCONFIG.Domain.HostName;
            const desktopUrl = TRPCONFIG.Domain.RedirectToDesktopUrl || `https://www.${domain}`;

            createDesktopCookie(domain);
            location.replace(desktopUrl);
        }]
    });

    $routeProvider.when('/apis-unsubscribe', {
        templateUrl: () => `unsubscribe/apisUnsubscribe${location.search}`
    });

    $routeProvider.when('/nps-unsubscribe', {
        templateUrl: () => `unsubscribe/npsUnsubscribe${location.search}`
    });

    if (TRPCONFIG.Domain.ShortlistsEnabled) {
        $routeProvider.when('/shortlist', {
            templateUrl: 'partials/shortlist/index',
            controller: 'Shortlist',
            controllerAs: 'cm',
            analyticsTag: 'Hotel Shortlist'
        });
    }

    if (TRPCONFIG.Domain.RecentHotelsEnabled) {
        $routeProvider.when('/recenthotels', {
            templateUrl: 'partials/recenthotels/index',
            controller: 'RecentHotels',
            controllerAs: 'cm',
            analyticsTag: 'Recent Hotels'
        });
    }

    $routeProvider.when('/error', {
        templateUrl: 'partials/home/error',
        analyticsTag: 'Error Page',
        pixelTrackingPageName: 'errorPage',
        controller($scope, broker) {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
    });

    $routeProvider.when('/errordatesmismatch', {
        templateUrl: 'partials/home/errordatesmismatch',
        analyticsTag: 'Error Page',
        pixelTrackingPageName: 'errorDatesMismatch',
        controller($scope, broker) {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
    });

    $routeProvider.when('/bookingalreadydone', {
        templateUrl: 'partials/home/bookingnotfound',
        analyticsTag: 'Booking Already Done',
        pixelTrackingPageName: 'bookingAlreadyDone',
        controller($scope, broker) {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
    });

    $routeProvider.when('/pagenotfound', {
        templateUrl: 'partials/home/pagenotfound',
        analyticsTag: 'Page Not Found',
        pixelTrackingPageName: 'pageNotFound',
        controller($scope, broker) {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
    });

    $routeProvider.when('/selectcountry', {
        templateUrl: 'partials/home/selectcountry'
    });

    $routeProvider.when('/holidays/flightunavailable', {
        templateUrl: 'partials/holidays/flightunavailable'
    });

    if (TRPCONFIG.Domain.PromotionTermsPageEnabled) {
        $routeProvider.when('/promotionterms', {
            templateUrl: 'partials/information/promotiontermsandcond',
            controller: 'PromotionTerms',
            controllerAs: 'pt'
        });
    }

    //this is just a little bit of routing required when paypal payment doesn't go through for some reason
    $routeProvider.when('/paypalfail/:tripId%', {
        template: '<div></div>',
        controller: ['$location', '$routeParams', 'basketStore', 'tripService', function($location, $routeParams, basketStore, tripService) {
            tripService.getTrip($routeParams.tripId).then(function(trip) {
                if (trip) {
                    basketStore.all(trip.BasketId).then(function(products) {
                        if (products.t != null) {
                            $location.url(`transfers/book/${$routeParams.tripId}?ppResp=${$routeParams.ppResp}`);
                        } else if (products.f != null) {
                            $location.url(`holidays/book/${$routeParams.tripId}?ppResp=${$routeParams.ppResp}`);
                        } else {
                            $location.url(`hotels/book/${$routeParams.tripId}?ppResp=${$routeParams.ppResp}`);
                        }
                    });
                }
            });
        }]
    });

    $routeProvider.when('/keymessages', {
        templateUrl: 'partials/home/keymessagestext',
        controller: ['$scope', '$window', function(scope, $window) {
            scrollTo(0, 0);
            scope.back = function() {
                setTimeout(function() {
                    $window.history.back();
                }, 0);
            };
        }]
    });

    $routeProvider.when('/landing-pages/destination.aspx', {
        redirectTo() {
            const destination = getDestination();
            if (destination == null) {
                return 'hotels';
            }
            if (destination.EstablishmentId > 0) {
                return `hotels/hotel/${destination.EstablishmentId}?pd=${destination.pd}`;
            }
            return `hotels?k=${destination.k}`;
        }
    });


    //$routeProvider.when('/keymessages', {
    //    templateUrl: 'partials/home/keymessagestext',
    //    controller: ['$scope', '$window', function (scope, $window) {
    //        scrollTo(0, 0);
    //        scope.back = function () {
    //            setTimeout(function () {
    //                $window.history.back();
    //            }, 0);
    //        };
    //    }]
    //});

    $routeProvider.when('/keymessages', {
        templateUrl: 'partials/home/keymessagestext',
        controller: ['$scope', '$window', function(scope, $window) {
            scrollTo(0, 0);
            scope.back = function() {
                setTimeout(function() {
                    $window.history.back();
                }, 0);
            };
        }]
    });

    if (!TRPCONFIG.Domain.CMSHomePageEnabled) {
        const newHomeConf = {
            bodyUncontained: true,
            templateUrl: 'partials/home/newindex'
        };

        const mobileHomeConf = {
            bodyUncontained: true,
            templateUrl: 'partials/home/newindex'
        };

        const superHeroConf = {
            bodyUncontained: true,
            templateUrl: 'partials/home/superherotest'
        };

        $routeProvider.when('/', Object.assign(
            {
                templateUrl: 'partials/home/index',
                controller: 'Home',
                area: isSupported('holidays') ? 'holidays' : 'hotels',
                strapLine: true,
                isResponsive: true,
                pixelTrackingPageName: 'homePage'
            },
            !isMobileSite() && TRPCONFIG.Domain.NewHomepageEnabled && newHomeConf,
            !isMobileSite() && TRPCONFIG.Domain.SuperheroBannerEnabled && superHeroConf,
            isMobileSite() && TRPCONFIG.Domain.NewMobileHomepageEnabled && mobileHomeConf
        ));
    }


    $routeProvider.when('/selectdomain', {
        templateUrl: 'livepartials/home/selectdomain',
        controllerAs: 'cm',
        controller: 'SelectDomain'
    });

    $routeProvider.when('/selectoffice', {
        templateUrl: 'livepartials/home/selectoffice',
        controllerAs: 'cm',
        controller: 'SelectOffice'
    });

    $routeProvider.when('/agentsettings', {
        templateUrl: 'livepartials/home/agentsettings',
        controllerAs: 'cm',
        controller: 'Agent'
    });

    $routeProvider.when('/brochure', {
        templateUrl: 'partials/home/brochure'
    });

    $routeProvider.when('/apps', {
        templateUrl: 'partials/home/apppromo',
        controllerAs: 'ap',
        controller: 'AppPromo'
    });

    $routeProvider.when('/test-page', {
        templateUrl: 'partials/information/testpage',
        controllerAs: 'cm',
        controller: 'TestPage'
    });

    $routeProvider.when('/test-home', {
        templateUrl: 'partials/information/testhome',
        controllerAs: 'cm',
        controller: 'TestHome',
        bodyUncontained: true
    });

    $routeProvider.when('/test-components', {
        templateUrl: 'partials/information/testcomponents'
    });

    if (TRPCONFIG.DynamicRoutingEnabled) {
        $routeProvider.otherwise({
            template: '<div ng-include="cc.template" class="ekh-outer-content"><h1>Loading...</h1></div>',
            controllerAs: 'cc',
            controller: 'DynamicRouting'
        });
    } else {
        $routeProvider.otherwise({ redirectTo: '/' });
    }

    delete $httpProvider.defaults.headers.common['X-Requested-With'];
    delete $httpProvider.defaults.headers.common['x-requested-with'];
    $locationProvider.html5Mode(true).hashPrefix('!');
}]);


TR.run([
    '$location', '$route', '$rootScope', 'authService', 'analytics', 'cancellerService', 'broker', 'authRedirection', 'cookieService', '$injector', '$templateCache', 'urlStoreService',
    function($location, $route, $rootScope, authService, analytics, cancellerService, broker, authRedirection, cookieService, $injector, $templateCache, urlStoreService) {

        $templateCache.put('loadingcmscomponent.html', '<div></div>');

        $rootScope.ShortlistsEnabled = TRPCONFIG.Domain.ShortlistsEnabled;
        $rootScope.EnableSavedSearches = TRPCONFIG.EnableSavedSearches;
        $rootScope.MenuEnabled = TRPCONFIG.MenuEnabled;
        $rootScope.ManageBookingEnabled = TRPCONFIG.ManageBookingEnabled;
        $rootScope.SignInEnabled = TRPCONFIG.SignInEnabled;

        analytics.pageLoad($location.absUrl());

        $rootScope.$on('$routeChangeSuccess', function() {
            analytics.routeChange($location.absUrl(), $location.url());
            if (TRPCONFIG.Domain.SalesforceChatEnabled && window.salesForceSetCurrentUrl) {
                window.salesForceSetCurrentUrl();
            }
            $rootScope.showErrors = false;
            broker.publish('selfdestruct');
            urlStoreService.pushURL();
        });

        $rootScope.$on('$routeChangeStart', function(ev, next) {
            if (sessionStorage.getItem('willRedirectionOccurByVWO') === 'true') {
                const vwoAbsUrl = sessionStorage.getItem('willRedirectionOccurByVWOAbsUrl');
                const vwoUrl = sessionStorage.getItem('willRedirectionOccurByVWOUrl');
                analytics.routeChange(vwoAbsUrl, vwoUrl);
                sessionStorage.removeItem('willRedirectionOccurByVWOAbsUrl');
                sessionStorage.removeItem('willRedirectionOccurByVWOUrl');
                sessionStorage.removeItem('willRedirectionOccurByVWO');
            }
            if ($location.search().utm_source && $location.search().utm_medium) {
                cookieService.set('CampaignReferrer', `${$location.search().utm_source}&&${$location.search().utm_medium}`);
            }

            const FeatureType = {
                Hotels: 'hotels',
                Destinations: 'destinations',
                Booking: 'booking',
                HotelsLanding: 'hotelsLanding',
                Flights: 'flights',
                Holidays: 'holidays',
                AdaptiveBooking: 'adaptiveBooking',
                AdaptiveHotels: 'adaptiveHotels',
                AdaptiveFlights: 'adaptiveFlights',
                AdaptiveHolidays: 'adaptiveHolidays'
            };

            const isPathAndFeatureTrue = (nextPath, featureType) => {
                const matchesPath = _.get(next, '$$route.originalPath') === nextPath;

                // Features that are permanently enabled to all users
                const parasolEnabledFeatures = _.get(TRPCONFIG, 'Domain.ParasolEnabledFeatures');
                const includesEnabledFeature = parasolEnabledFeatures && parasolEnabledFeatures.includes(featureType);

                // Features that are part of a test and can only be access by authenticated users
                const parasolTestingFeatures = _.get(TRPCONFIG, 'Domain2.ParasolTestingFeatures');
                const includesTestingFeature = parasolTestingFeatures && parasolTestingFeatures.includes(featureType);
                const testUserAuthenticated = cookieService.get('x-v3') === 'true' || cookieService.get('x-v3') === TRPCONFIG.Domain.ParasolVWOTestId;

                return matchesPath && (includesEnabledFeature || (testUserAuthenticated && includesTestingFeature));
            };

            const isPathAndFeatureTrueAcc = (acc, { nextPath, featureType }) => acc || isPathAndFeatureTrue(nextPath, featureType);

            const isBookingOptionalExtraTrue = selectedOptions => {
                if (selectedOptions && selectedOptions.length > 0) {
                    const supportedOptions = _.get(TRPCONFIG, 'Domain2.ParasolAdaptiveBookingExtras');
                    const allOptionsSupported = _.intersection(supportedOptions, selectedOptions);
                    return (allOptionsSupported.length > 0) &&
                        (selectedOptions.length > 0) &&
                        (allOptionsSupported.length === selectedOptions.length);
                }
            };

            const matchV3Destinations = currentPath => /\/1-[0-9]{1,5}-2-0\//.test(currentPath);

            const matchV2HotelsLandings = currentPath => /\/2-[0-9]{1,6}\//.test(currentPath);

            // Adds cookie if EnableV3 is set to true in VWO and it doesn't have a cookie yet
            if (TRPCONFIG.Domain.TestingV3 && TRPCONFIG.EnableV3 === true && cookieService.get('x-v3') == null) {
                cookieService.set('x-v3', TRPCONFIG.Domain.ParasolVWOTestId, false, false, true, 'none');
            }

            const isV2Request = $location.search().gov && $location.search().gov === '2';

            // Regarding m., need to keep these hosts names in else it will start trying to move
            // dnata and others onto v3 as well.
            const isOurMobileHostname = window.location.hostname.startsWith('m.travelrepublic') ||
                window.location.hostname.startsWith('m.pp.travelrepublic') ||
                window.location.hostname.startsWith('m.bf.travelrepublic') ||
                window.location.hostname.startsWith('m.qa.travelrepublic') ||
                (TRPCONFIG.IsMobileView && TRPCONFIG.IsCombinedViewMode);

            const isOurLocalDevHostname = /(www|m).dev.travelrepublic/.test(window.location.hostname);

            const isAdaptiveBookingCompleteRoute = [
                { nextPath: '/booking/complete/:ref*', featureType: FeatureType.AdaptiveBooking },
                { nextPath: '/booking/complete', featureType: FeatureType.AdaptiveBooking }
            ].reduce(isPathAndFeatureTrueAcc, false);

            const isAdaptiveRoute = isAdaptiveBookingCompleteRoute || [
                { nextPath: '/hotels/book/:tripId%', featureType: FeatureType.AdaptiveBooking },
                { nextPath: '/holidays/book/:tripId%', featureType: FeatureType.AdaptiveBooking },
                { nextPath: '/hotels/:tripId%/:estabId', featureType: FeatureType.AdaptiveHotels },
                { nextPath: '/hotels/:tripId%', featureType: FeatureType.AdaptiveHotels },
                { nextPath: '/flights/:tripId%', featureType: FeatureType.AdaptiveFlights },
                { nextPath: '/holidays/hotels/:tripId%', featureType: FeatureType.AdaptiveHolidays },
                { nextPath: '/holidays/hotels/:tripId%/:estabId', featureType: FeatureType.AdaptiveHolidays },
                { nextPath: '/holidays/flights/:tripId%', featureType: FeatureType.AdaptiveHolidays },
                { nextPath: '/holidays/options/:tripId%', featureType: FeatureType.AdaptiveHolidays }
            ].reduce(isPathAndFeatureTrueAcc, false);

            const isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
            const MetaTrafficIds = _.get(TRPCONFIG, 'Domain2.MetaTrafficIds');
            const isntMetaTraffic = MetaTrafficIds && !MetaTrafficIds.includes(cookieService.get('visitSource'));

            // We're now taking into account agents and metachannel traffic (by checking the visitSource cookie) and we reroute to v2
            if (TRPCONFIG.Domain.TestingV3 && !isV2Request && (isOurMobileHostname || isAdaptiveRoute) && !isOurLocalDevHostname && !isAgentMode && isntMetaTraffic) {
                const currPath = $location.path();
                const adaptiveBookingFlags = JSON.parse(sessionStorage.getItem('adaptiveBookingFlags'));

                // are we on a V3 supported route?
                if ((matchV3Destinations(currPath) && isPathAndFeatureTrue('/:landingPageV3£/:urlText*', FeatureType.Destinations)) ||
                    (matchV2HotelsLandings(currPath) && isPathAndFeatureTrue('/:landingPageV2€/:urlText*', FeatureType.HotelsLanding)) || [
                        { nextPath: '/hotels/:tripId%/:estabId', featureType: FeatureType.Hotels },
                        { nextPath: '/hotels/:tripId%', featureType: FeatureType.Hotels },
                        { nextPath: '/flights/:tripId%', featureType: FeatureType.Flights },
                        { nextPath: '/holidays/hotels/:tripId%', featureType: FeatureType.Holidays },
                        { nextPath: '/holidays/hotels/:tripId%/:estabId', featureType: FeatureType.Holidays },
                        { nextPath: '/holidays/flights/:tripId%', featureType: FeatureType.Holidays },
                        { nextPath: '/holidays/options/:tripId%', featureType: FeatureType.Holidays }
                    ].reduce(isPathAndFeatureTrueAcc, false)
                ) {
                    ev.preventDefault();
                    window.location.href = currPath.replace('/holidays/flights/', '/holidays/hotels/');
                }

                // check if they're going to booking complete and have come from a V2 holiday
                // but if its an adaptive booking journey route it to V3
                if (!isAdaptiveBookingCompleteRoute && [
                        { nextPath: '/booking/complete/:ref*', featureType: FeatureType.Booking },
                        { nextPath: '/booking/complete', featureType: FeatureType.Booking }
                    ].reduce(isPathAndFeatureTrueAcc, false)
                ) {
                    ev.preventDefault();
                    if (sessionStorage.getItem('eCommercePurchaseData')) {
                        // if booking has eCommerce data re-route it to V2 booking complete
                        window.location.href = `${currPath}${currPath.match(/\?/) ? '&' : '?'}gov=2`;
                    } else {
                        // route traffic on immediately
                        window.location.href = currPath;
                    }
                }

                // are we on a V3 adaptive booking route and are our booking options supported on V3?
                if (isAdaptiveRoute && isBookingOptionalExtraTrue(adaptiveBookingFlags)) {
                    ev.preventDefault();
                    window.location.href = currPath.replace('/holidays/book/', '/booking/passengers/');
                }
            }
            let redirect = true;
            const user = authService.getUser();

            if ($location.search().rl === '1') {
                $location.replace();
                $location.search('rl', null);
                $route.reload();
            }

            cancellerService.process($location.path());

            const allowedAgentRoutes = ['/agents/initiateresetpassword', '/admin/resetpassword', '/agents/resetsuccessful'];

            if (user && !user.Agent && TRPCONFIG.Domain.IsAgentDomain && allowedAgentRoutes.indexOf($location.path()) === -1) {
                $rootScope.$evalAsync(() => {
                    $location.path('agents/signin').search({ Dest: TRPCONFIG.Domain.AgentLogonUrlDest });
                });
                return;
            }

            if (!next.requiresHardAuth && !next.requiresAnonAuth) {
                redirect = false;
            }

            if (next.requiresHardAuth && user && user.HardSignedIn) {
                redirect = false;
            }

            if (next.requiresAnonAuth && user && (user.AnonSignedIn || user.HardSignedIn)) {
                redirect = false;
            }

            if (redirect) {
                authService.bufferRoute($location.url());
                $location.replace();
                const redirectUrl = !next.requiresHardAuth && next.requiresAnonAuth ? 'bookingsignin' : 'signin';
                authRedirection.authRedirect(redirectUrl, null, next.params);
            }
        });
    }]);
})();
